import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CountDownComponent } from './count-down/count-down.component';
import { CountDownOptions } from './count-down/models/count-down-options';
import { DialogSessionTimeoutData } from './models/dialog-session-timeout-data';

@Component({
    selector: 'app-session-timeout',
    templateUrl: './session-timeout.component.html',
    styleUrls: ['./session-timeout.component.scss'],
    imports: [MatCardModule, CountDownComponent, MatButtonModule]
})
export class SessionTimeoutComponent {
    /**
     * Options du compteur.
     */
    public countDownOptions = new CountDownOptions(false, false, true, true);

    /**
     * Constructeur.
     * @param dialogRef
     */
    constructor(
        public dialogRef: MatDialogRef<SessionTimeoutComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogSessionTimeoutData
    ) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Non'.
     */
    public close(): void {
        this.dialogRef.close(false);
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Oui'.
     */
    public extend(): void {
        this.dialogRef.close(true);
    }

    /**
     *
     * @param event Appelée lorsque le compteur arrive à 0.
     */
    public onFinished(event) {
        this.dialogRef.close(false);
    }
}
